var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { FC, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled from 'styled-components';
import { BigImageShadow, BigImageText } from '../bigimage';
import GridDrag from '../../../../GridDrag';
import AspectRatio from '../../../../AspectRatio';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { ImageTextShadow, TextEditWrapper } from '../../../../Text/styles';
import { WIDE_PRESENTATION_RATIO } from '../../../../../constants/media';
import { AddFourRowBtn, AddTextBottom, AddTextCaption, AddTextCenter, AddTextTop, AddThreeRowBtn, AddTwoRowBtn } from '../EditorToolbar/styles';
import { createPortal } from 'react-dom';
import CaptionEdit from '../CaptionEdit';
import { FlexBox, HintTooltip } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import { EditorToolbarCheckBox } from '../../../modules/inputs/EditorToolbarCheckBox';
import { TileViewType } from '../../../../../constants/TyleViewType';
var initialEditedSlide = {
    id: null,
    mode: null
};
var CaptionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  z-index: 8;\n"], ["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  z-index: 8;\n"])));
var SliderRibbonLabel = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #909090;\n"], ["\n  color: #909090;\n"])));
export var SliderEditBlock = function (_a) {
    var _b;
    var srcList = _a.srcList, onSetSortedImg = _a.onSetSortedImg, onTileViewTypeChange = _a.onTileViewTypeChange, onImgRemove = _a.onImgRemove, onSlideTextChange = _a.onSlideTextChange, handleSlideChecked = _a.handleSlideChecked, TAOnChange = _a.TAOnChange, TAvalue = _a.TAvalue, captionMode = _a.captionMode, textPosition = _a.textPosition, controlsPlacer = _a.controlsPlacer, caption = _a.caption, isLoading = _a.isLoading, isRibbon = _a.isRibbon, maxCount = _a.maxCount, tileViewType = _a.tileViewType, style = _a.style;
    var _c = useCommonProps(), fixedRatio = _c.fixedRatio, viewType = _c.viewType;
    var _d = useState(false), editingText = _d[0], setEditingText = _d[1];
    var _e = useState(textPosition), position = _e[0], setPosition = _e[1];
    var _f = useState(false), isLink = _f[0], setIsLink = _f[1];
    var _g = useState(initialEditedSlide), editedSlide = _g[0], setEditedSlide = _g[1];
    var _h = useState(null), hoveredImageIndex = _h[0], setHoveredImageIndex = _h[1];
    var _j = useState(!!isRibbon), checked = _j[0], setChecked = _j[1];
    var isTransferMediia = ['free-type'].includes(viewType);
    useEffect(function () {
        if (isTransferMediia) {
            handleSlideChecked(checked);
        }
    }, [checked, isTransferMediia]);
    var handleMouseEnter = function (index) {
        setHoveredImageIndex(index);
    };
    var handleMouseLeave = function () {
        setHoveredImageIndex(null);
    };
    var hoveredTextPosition = hoveredImageIndex !== null ? (_b = srcList === null || srcList === void 0 ? void 0 : srcList[hoveredImageIndex]) === null || _b === void 0 ? void 0 : _b.textPosition : null;
    var textInputVisible = useMemo(function () { return editingText && TAOnChange && captionMode === 'big'; }, [editingText, TAOnChange, captionMode]);
    var hasTextEditor = useMemo(function () { return Boolean(!(TAvalue === null || TAvalue === void 0 ? void 0 : TAvalue.length)); }, [TAvalue]);
    var hasSlideText = useMemo(function () { return (srcList === null || srcList === void 0 ? void 0 : srcList.some(function (i) { var _a; return !!((_a = i === null || i === void 0 ? void 0 : i.text) === null || _a === void 0 ? void 0 : _a.length); })); }, [srcList]);
    var hasSliderText = useMemo(function () { return caption === null || caption === void 0 ? void 0 : caption.length; }, [TAvalue]);
    var maxCaptionLength = useMemo(function () {
        return style === 'tile' ? '100' : undefined;
    }, [style]);
    var t = useLocalization().t;
    var handleButtonClick = function (position) {
        if (!(editedSlide === null || editedSlide === void 0 ? void 0 : editedSlide.id)) {
            setEditingText(true);
        }
        setPosition(position);
    };
    var handleSubmit = function (text) {
        TAOnChange(text, position);
        setEditingText(false);
        setPosition(position);
    };
    var onCancel = function () {
        setEditingText(false);
        setPosition(null);
        setEditedSlide(initialEditedSlide);
    };
    var handleSlideEditToggle = function (id, mode, textPosition) {
        var _a;
        if ((_a = ['text_mode', 'link_mode']) === null || _a === void 0 ? void 0 : _a.includes(mode)) {
            setEditedSlide({ id: id, mode: mode });
            setPosition(textPosition || 'bottom');
        }
        else {
            setEditedSlide(initialEditedSlide);
            setPosition(null);
        }
    };
    var handleSlideTextChange = function (id, text) {
        onSlideTextChange(id, text, position, editedSlide.mode);
        setEditedSlide(initialEditedSlide);
    };
    var handleLinkChange = function (id, text) {
        onSlideTextChange(id, text, position);
        setEditedSlide(initialEditedSlide);
    };
    var handleChecked = function () {
        setChecked(function (prev) {
            var newValue = !prev;
            return newValue;
        });
    };
    var controlsButtons = useMemo(function () {
        if (style === 'tile') {
            return (React.createElement(React.Fragment, null,
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.two_row') },
                    React.createElement(AddTwoRowBtn, { active: tileViewType === TileViewType.twoRow, onClick: function () { return onTileViewTypeChange(TileViewType.twoRow); } })),
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.three_row') },
                    React.createElement(AddThreeRowBtn, { active: tileViewType === TileViewType.threeRow, onClick: function () { return onTileViewTypeChange(TileViewType.threeRow); } })),
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.four_row') },
                    React.createElement(AddFourRowBtn, { active: tileViewType === TileViewType.fourRow, onClick: function () { return onTileViewTypeChange(TileViewType.fourRow); } }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_top') },
                React.createElement(AddTextTop, { active: (hoveredTextPosition || position) === 'top', onClick: function () { return handleButtonClick('top'); } })),
            React.createElement(HintTooltip, { z: 3, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_center') },
                React.createElement(AddTextCenter, { active: (hoveredTextPosition || position) === 'center', onClick: function () { return handleButtonClick('center'); } })),
            React.createElement(HintTooltip, { z: 2, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_bottom') },
                React.createElement(AddTextBottom, { active: (hoveredTextPosition || position) === 'bottom', onClick: function () { return handleButtonClick('bottom'); } })),
            React.createElement(HintTooltip, { z: 1, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_under') },
                React.createElement(AddTextCaption, { active: (hoveredTextPosition || position) === 'caption-bottom', onClick: function () { return handleButtonClick('caption-bottom'); } })),
            isTransferMediia && React.createElement(FlexBox, { align: 'center', justify: 'center' },
                React.createElement(EditorToolbarCheckBox, { value: checked, onChange: handleChecked, label: t('hint.checkbox_label') }))));
    }, [
        position,
        style,
        viewType,
        tileViewType,
        hoveredTextPosition,
        srcList,
        editedSlide,
        hasSlideText,
        checked
    ]);
    var controls = useMemo(function () {
        if (controlsPlacer) {
            // if (hasSlideText) {
            //   return null;
            // }
            return createPortal(controlsButtons, controlsPlacer);
        }
    }, [controlsPlacer, controlsButtons]);
    return (React.createElement(AspectRatio, { ratio: fixedRatio || WIDE_PRESENTATION_RATIO },
        editingText && (React.createElement(CaptionWrapper, null,
            React.createElement(CaptionEdit, { value: position === 'caption-bottom' || position === 'caption'
                    ? caption
                    : TAvalue, onSubmit: handleSubmit, onCancel: onCancel, deleteVisible: true }))),
        controls,
        React.createElement(GridDrag, { list: srcList, onSetSortedImg: onSetSortedImg, onImgRemove: onImgRemove, onSlideTextChange: handleSlideTextChange, onSlideEditToggle: handleSlideEditToggle, onLinkChange: handleLinkChange, editedSlide: editedSlide, hasTextEditor: hasTextEditor, hasSliderText: hasSliderText, blackTheme: true, style: style, maxCaptionLength: maxCaptionLength, isMultiple: false, isLoading: isLoading, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=SliderEditBlock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { FC, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { TextareaAutosize } from 'brg-react-resize-textarea';
import styled from 'styled-components';
import { BigImageShadow, BigImageText } from '../bigimage';
import GridDrag from '../../../../GridDrag';
import AspectRatio from '../../../../AspectRatio';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { ImageTextShadow, TextEditWrapper } from '../../../../Text/styles';
import { WIDE_PRESENTATION_RATIO } from '../../../../../constants/media';
import { AddFourRowBtn, AddTextBottom, AddTextCaption, AddTextCenter, AddTextTop, AddThreeRowBtn, AddTwoRowBtn } from '../EditorToolbar/styles';
import { createPortal } from 'react-dom';
import CaptionEdit from '../CaptionEdit';
import { FlexBox, HintTooltip } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import { EditorToolbarCheckBox } from '../../../modules/inputs/EditorToolbarCheckBox';
import { TileViewType } from '../../../../../constants/TyleViewType';
var initialEditedSlide = {
    id: null,
    mode: null
};
var CaptionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  z-index: 8;\n"], ["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  z-index: 8;\n"])));
var SliderRibbonLabel = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #909090;\n"], ["\n  color: #909090;\n"])));
export var SliderEditBlock = function (_a) {
    var _b;
    var srcList = _a.srcList, onSetSortedImg = _a.onSetSortedImg, onTileViewTypeChange = _a.onTileViewTypeChange, onImgRemove = _a.onImgRemove, onSlideTextChange = _a.onSlideTextChange, handleSlideChecked = _a.handleSlideChecked, TAOnChange = _a.TAOnChange, TAvalue = _a.TAvalue, captionMode = _a.captionMode, textPosition = _a.textPosition, controlsPlacer = _a.controlsPlacer, caption = _a.caption, isLoading = _a.isLoading, isRibbon = _a.isRibbon, maxCount = _a.maxCount, tileViewType = _a.tileViewType, style = _a.style;
    var _c = useCommonProps(), fixedRatio = _c.fixedRatio, viewType = _c.viewType;
    var _d = useState(false), editingText = _d[0], setEditingText = _d[1];
    var _e = useState(textPosition), position = _e[0], setPosition = _e[1];
    var _f = useState(false), isLink = _f[0], setIsLink = _f[1];
    var _g = useState(initialEditedSlide), editedSlide = _g[0], setEditedSlide = _g[1];
    var _h = useState(null), hoveredImageIndex = _h[0], setHoveredImageIndex = _h[1];
    var _j = useState(!!isRibbon), checked = _j[0], setChecked = _j[1];
    var isTransferMediia = ['free-type'].includes(viewType);
    useEffect(function () {
        if (isTransferMediia) {
            handleSlideChecked(checked);
        }
    }, [checked, isTransferMediia]);
    var handleMouseEnter = function (index) {
        setHoveredImageIndex(index);
    };
    var handleMouseLeave = function () {
        setHoveredImageIndex(null);
    };
    var hoveredTextPosition = hoveredImageIndex !== null ? (_b = srcList === null || srcList === void 0 ? void 0 : srcList[hoveredImageIndex]) === null || _b === void 0 ? void 0 : _b.textPosition : null;
    var textInputVisible = useMemo(function () { return editingText && TAOnChange && captionMode === 'big'; }, [editingText, TAOnChange, captionMode]);
    var hasTextEditor = useMemo(function () { return Boolean(!(TAvalue === null || TAvalue === void 0 ? void 0 : TAvalue.length)); }, [TAvalue]);
    var hasSlideText = useMemo(function () { return (srcList === null || srcList === void 0 ? void 0 : srcList.some(function (i) { var _a; return !!((_a = i === null || i === void 0 ? void 0 : i.text) === null || _a === void 0 ? void 0 : _a.length); })); }, [srcList]);
    var hasSliderText = useMemo(function () { return caption === null || caption === void 0 ? void 0 : caption.length; }, [TAvalue]);
    var maxCaptionLength = useMemo(function () {
        return style === 'tile' ? '100' : undefined;
    }, [style]);
    var t = useLocalization().t;
    var handleButtonClick = function (position) {
        if (!(editedSlide === null || editedSlide === void 0 ? void 0 : editedSlide.id)) {
            setEditingText(true);
        }
        setPosition(position);
    };
    var handleSubmit = function (text) {
        TAOnChange(text, position);
        setEditingText(false);
        setPosition(position);
    };
    var onCancel = function () {
        setEditingText(false);
        setPosition(null);
        setEditedSlide(initialEditedSlide);
    };
    var handleSlideEditToggle = function (id, mode, textPosition) {
        var _a;
        if ((_a = ['text_mode', 'link_mode']) === null || _a === void 0 ? void 0 : _a.includes(mode)) {
            setEditedSlide({ id: id, mode: mode });
            setPosition(textPosition || 'bottom');
        }
        else {
            setEditedSlide(initialEditedSlide);
            setPosition(null);
        }
    };
    var handleSlideTextChange = function (id, text) {
        onSlideTextChange(id, text, position, editedSlide.mode);
        setEditedSlide(initialEditedSlide);
    };
    var handleLinkChange = function (id, text) {
        onSlideTextChange(id, text, position);
        setEditedSlide(initialEditedSlide);
    };
    var handleChecked = function () {
        setChecked(function (prev) {
            var newValue = !prev;
            return newValue;
        });
    };
    var controlsButtons = useMemo(function () {
        if (style === 'tile') {
            return (React.createElement(React.Fragment, null,
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.two_row') },
                    React.createElement(AddTwoRowBtn, { active: tileViewType === TileViewType.twoRow, onClick: function () { return onTileViewTypeChange(TileViewType.twoRow); } })),
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.three_row') },
                    React.createElement(AddThreeRowBtn, { active: tileViewType === TileViewType.threeRow, onClick: function () { return onTileViewTypeChange(TileViewType.threeRow); } })),
                React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.four_row') },
                    React.createElement(AddFourRowBtn, { active: tileViewType === TileViewType.fourRow, onClick: function () { return onTileViewTypeChange(TileViewType.fourRow); } }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(HintTooltip, { z: 4, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_top') },
                React.createElement(AddTextTop, { active: (hoveredTextPosition || position) === 'top', onClick: function () { return handleButtonClick('top'); } })),
            React.createElement(HintTooltip, { z: 3, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_center') },
                React.createElement(AddTextCenter, { active: (hoveredTextPosition || position) === 'center', onClick: function () { return handleButtonClick('center'); } })),
            React.createElement(HintTooltip, { z: 2, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_bottom') },
                React.createElement(AddTextBottom, { active: (hoveredTextPosition || position) === 'bottom', onClick: function () { return handleButtonClick('bottom'); } })),
            React.createElement(HintTooltip, { z: 1, h: '32px', positionY: 'bottom', noArrow: true, text: t('hint.image_under') },
                React.createElement(AddTextCaption, { active: (hoveredTextPosition || position) === 'caption-bottom', onClick: function () { return handleButtonClick('caption-bottom'); } })),
            isTransferMediia && React.createElement(FlexBox, { align: 'center', justify: 'center' },
                React.createElement(EditorToolbarCheckBox, { value: checked, onChange: handleChecked, label: t('hint.checkbox_label') }))));
    }, [
        position,
        style,
        viewType,
        tileViewType,
        hoveredTextPosition,
        srcList,
        editedSlide,
        hasSlideText,
        checked
    ]);
    var controls = useMemo(function () {
        if (controlsPlacer) {
            // if (hasSlideText) {
            //   return null;
            // }
            return createPortal(controlsButtons, controlsPlacer);
        }
    }, [controlsPlacer, controlsButtons]);
    return (React.createElement(AspectRatio, { ratio: fixedRatio || WIDE_PRESENTATION_RATIO },
        editingText && (React.createElement(CaptionWrapper, null,
            React.createElement(CaptionEdit, { value: position === 'caption-bottom' || position === 'caption'
                    ? caption
                    : TAvalue, onSubmit: handleSubmit, onCancel: onCancel, deleteVisible: true }))),
        controls,
        React.createElement(GridDrag, { list: srcList, onSetSortedImg: onSetSortedImg, onImgRemove: onImgRemove, onSlideTextChange: handleSlideTextChange, onSlideEditToggle: handleSlideEditToggle, onLinkChange: handleLinkChange, editedSlide: editedSlide, hasTextEditor: hasTextEditor, hasSliderText: hasSliderText, blackTheme: true, style: style, maxCaptionLength: maxCaptionLength, isMultiple: false, isLoading: isLoading, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=SliderEditBlock.js.map